<div class="rtc-grid rtc-margin-bottom-20 rtc-padding-10">
  <div class="rtc-grid-item-12 rtc-versao rtc-text-align-center">
    <span [ngClass]="{'versao-problema': versaoProblema}">
      {{`Versão: ${versaoExecucao?.versaoDb} - ${versaoExecucao?.versaoApp} - ${versaoExecucao?.ambiente.toUpperCase()}`}}</span>
    <span>&nbsp;&nbsp;</span>
    <span [placement]="placement" [tooltip]="versaoTooltip">
      <i
        [ngClass]="versaoProblema ? 'fa-solid fa-triangle-exclamation rtc-warning' : 'fa-solid fa-circle-info rtc-info'"
      ></i>
    </span>
  </div>
</div>